import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import * as styles from './style';
import EditableTitle from '../../components/EditableTitle';
import GenericList from '../../components/GenericList';
import ProductListItem from '../../components/ProductListItem';
import withCreateMenu from '../../containers/CreateMenu';
import Storage from '../../helpers/storage';
import { NEW_MENU_STORAGE_KEY, SALE_TYPES, PATHS } from '../../helpers/constants';
import FormFooter from '../../components/FormFooter';
import DeleteMenuModal from '../../components/GenericModal/DeleteMenuModal';
import { withMenu } from '../../containers/Menus';
import withMenuModals from '../../containers/Modals/menu';
import PublishMenuModal from '../../components/PublishMenuModal';
import MarketplacesTags from '../../components/MarketplacesTags';
import DeliveryIcon from '../../images/icon-delivery.svg';
import TakeawayIcon from '../../images/icon-takeaway.svg';
import withCreateUhuuMenu from '../../containers/CreateUhuuMenu';
import EditConfirmationModal from '../../components/GenericModal/EditConfirmationModal';

const INITIAL_ERROR_STATE = {
  title: {
    isInvalid: false,
    message: null,
  },
  products: {
    isInvalid: false,
    isInvalidQtd: false,
    message: null,
  },
};

class SelectProducts extends PureComponent {
  state = {
    title: '',
    serviceTypes: [],
    marketplaces: [],
    error: { ...INITIAL_ERROR_STATE },
  };

  componentDidMount() {
    const menuData = Storage.getLocalStorage(NEW_MENU_STORAGE_KEY);
    const { getAllProductsByStatus, setMenuData, setCategories, history, getMenus } = this.props;

    getMenus();

    if (menuData) {
      this.setState({
        title: menuData.title || menuData.name || '',
        serviceTypes: menuData.serviceTypes || [],
        marketplaces: menuData.marketplaces || [],
        saleType: menuData.menuUhuuTypeId || menuData.saleType,
      });

      setMenuData(menuData);

      if (menuData.categories && menuData.categories.length) {
        setCategories(menuData.categories);
      } else {
        getAllProductsByStatus(1);
      }
    } else {
      history.goBack();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      newMenu,
      categories,
      menuCreated,
      menus,
      isLoadingMenus,
      isCreateMenuFinished,
      isEditMenuFinished,
      menuError,
      isPublishMenuFinished,
      finishCreateMenu,
      finishEditMenu,
      clearEvents,
      onClickMenuActions,
      setCategories,
      clearProductsSelected,
      showModal,
    } = this.props;

    const hasCategoriesToCompare =
      categories.length > 0 &&
      newMenu.categories.length > 0 &&
      categories.length === newMenu.categories.length;

    if (hasCategoriesToCompare) {
      if (this.differentNumberOfProducts(categories, newMenu.categories)) {
        setCategories(categories);
      }
    }

    if (!this.hasStoredProducts() && categories.length !== newMenu.categories.length) {
      setCategories(categories);
    }

    if ((isCreateMenuFinished || isEditMenuFinished) && !menuError) {
      finishCreateMenu();
      finishEditMenu();
      clearEvents();
      Storage.removeLocalStorage(NEW_MENU_STORAGE_KEY);
      if (isCreateMenuFinished) {
        onClickMenuActions('publish', { ...menuCreated });
      } else if (isEditMenuFinished) {
        showModal('edit-confirmation');
      }
    }

    if (isPublishMenuFinished) {
      clearProductsSelected();
    }

    if (!isLoadingMenus && prevProps.isLoadingMenus && newMenu.menu.id) {
      setCategories(
        newMenu.categories.map(cat => {
          const menuCat = menus
            .find(m => m.id === newMenu.menu.id)
            .categories.find(c => c.id === cat.id);
          if (menuCat) {
            return {
              ...cat,
              products: cat.products.map(prod => {
                if (prod.checked) {
                  const prodMenu = menuCat.products.find(p => p.id === prod.id);
                  if (prodMenu) {
                    return {
                      ...prod,
                      originalPrice: prodMenu.price,
                    };
                  }
                }
                return prod;
              }),
            };
          }
          return cat;
        })
      );
    }
  }

  componentWillUnmount() {
    const { clearNewMenuCategories, clearMenuErrors } = this.props;

    clearNewMenuCategories();
    clearMenuErrors();
  }

  differentNumberOfProducts = (categories, newMenuCategories) => {
    return categories.some(
      (cat, index) => cat.products.length !== newMenuCategories[index].products.length
    );
  };

  hasStoredProducts = () => {
    const menuData = Storage.getLocalStorage(NEW_MENU_STORAGE_KEY);

    return menuData && menuData.categories && menuData.categories.length;
  };

  onCancel = () => {
    const { clearProductsSelected, history, isUhuuMtkpc } = this.props;

    clearProductsSelected();
    history.push(isUhuuMtkpc() ? PATHS.createMenuUhuu : PATHS.menu);
  };

  validateForm = menu => {
    const { isUhuuMtkpc } = this.props;
    const { title, saleType } = this.state;
    const hasProductsSelected = !!menu.menuItems.length;
    const maxQuantitySelected =
      !(saleType === SALE_TYPES.specificMenu || saleType === SALE_TYPES.defaultMenu) ||
      !(menu.menuItems.length > 8);
    const allQuantitySelected =
      !isUhuuMtkpc() || menu.menuItems.every(prod => !!Number(prod.quantity));
    let error = { ...INITIAL_ERROR_STATE };

    if (!hasProductsSelected) {
      error = {
        ...error,
        products: {
          isInvalid: true,
          message: 'Você precisa selecionar pelo menos um produto para criar o cardápio',
        },
      };
    } else if (!allQuantitySelected) {
      error = {
        ...error,
        products: {
          ...error.products,
          isInvalidQtd: true,
          message: 'Você precisa selecionar a quantidade de todos os produtos',
        },
      };
    } else if (!maxQuantitySelected) {
      error = {
        ...error,
        products: {
          isInvalidMaxQtd: true,
          message:
            'Você selecionou uma quantidade excedida de produtos (máximo de 8 para este tipo de cardápio)',
        },
      };
    } else if (!title) {
      error = {
        ...error,
        title: {
          isInvalid: true,
          message: 'Você precisa informar o título do cardápio',
        },
      };
    }

    this.setState({ error });

    return Object.keys(error).every(
      key => !error[key].isInvalid && !error[key].isInvalidQtd && !error[key].isInvalidMaxQtd
    );
  };

  linkMenus = newMenu => {
    const { menus } = this.props;
    const selectedMenu = menus.find(menu => menu.id === newMenu.id);

    if (
      newMenu.menuItems.length ===
      selectedMenu.categories.reduce((curr, next) => curr + next.products.length, 0)
    ) {
      return newMenu;
    }

    let menuItems = [...newMenu.menuItems];

    selectedMenu.categories.forEach(menu => {
      const inactiveProducts = menu.products.filter(
        product => !menuItems.some(item => item.productId === product.id) && product.status === 0
      );

      if (inactiveProducts.length > 0) {
        menuItems = [
          ...menuItems,
          ...inactiveProducts.reduce(
            (array, product) => [
              ...array,
              {
                productId: product.id,
                price: product.price,
              },
            ],
            []
          ),
        ];
      }
    });

    return {
      ...newMenu,
      menuItems,
    };
  };

  saveMenu = () => {
    const { editMenu, createMenu } = this.props;
    let menu = this.getMenuData();

    if (this.validateForm(menu)) {
      if (menu.id) {
        menu = this.linkMenus(menu);

        editMenu(menu);
      } else {
        createMenu(menu);
      }
    }
  };

  getMenuData = () => {
    const { newMenu } = this.props;
    const { title } = this.state;
    const menu = newMenu.menu || {};

    let menuData = {
      name: title,
      published: !!menu.published,
      menuItems: this.formatSubmitProducts(),
      delivery: menu.serviceTypes.some(service => service.value === 'delivery'),
      takeaway: menu.serviceTypes.some(service => service.value === 'takeaway'),
      shortDelivery: menu.serviceTypes.some(service => service.value === 'shortDelivery'),
      voucher: menu.serviceTypes.some(service => service.value === 'voucher'),
      dineIn: menu.serviceTypes.some(service => service.value === 'dineIn'),
      marketplaces: menu.marketplaces.map(mktpc => mktpc.id),
      merchantId: Storage.getLocalStorageMerchant().idUnity,
      merchants: menu.merchants,
      ...this.getUhuuData(),
    };

    if (menu.id) {
      menuData = {
        ...menuData,
        id: menu.id,
        salesDateBegin: menu.salesDateBegin || null,
        salesDateEnd: menu.salesDateEnd || null,
        salesDaysOfWeek: menu.salesDaysOfWeek || null,
      };
    }

    return menuData;
  };

  getUhuuData = () => {
    const { newMenu, isUhuuMtkpc } = this.props;
    const { menu } = newMenu;

    return isUhuuMtkpc()
      ? {
          menuUhuuTypeId: menu.menuUhuuTypeId || Number(menu.saleType),
          uhuuEvents: menu.uhuuEvents,
        }
      : {};
  };

  formatSubmitProducts = () => {
    const { newMenu, isUhuuMtkpc } = this.props;
    const products = [];

    newMenu.categories.forEach(cat => {
      cat.products.forEach(prod => {
        if (prod.checked) {
          let product = {};
          product = {
            productId: prod.id,
            price: prod.originalPrice,
          };
          if (prod.salesPrice) {
            product = {
              ...product,
              salesPrice: prod.salesPrice,
              salesDescription: prod.salesDescription,
            };
          }
          if (isUhuuMtkpc()) {
            product = {
              ...product,
              quantity: prod.quantity,
            };
          }
          products.push(product);
        }
      });
    });

    return products;
  };

  renderServices = () => {
    const { serviceTypes } = this.state;
    let typesToRender = null;

    if (serviceTypes.length) {
      const deliveryTypeIdx = serviceTypes.findIndex(type => type.value === 'delivery');
      const hasTakeawayServices = serviceTypes.some(type => type.value !== 'delivery');

      if (deliveryTypeIdx > -1) {
        typesToRender = (
          <styles.Service id="info-delivery">
            <styles.Icon src={DeliveryIcon} />
            {serviceTypes[deliveryTypeIdx].label}
          </styles.Service>
        );
      }

      if (hasTakeawayServices) {
        typesToRender = (
          <Fragment>
            {typesToRender}
            <styles.Service id="info-takeaway">
              <styles.Icon src={TakeawayIcon} />
              No Local ({' '}
              {serviceTypes
                .filter(type => type.value !== 'delivery')
                .map(type => type.label)
                .join(', ')}{' '}
              )
            </styles.Service>
          </Fragment>
        );
      }
    }

    return typesToRender;
  };

  handleTitle = e => this.setState({ title: e.target.value });

  getError = () => {
    const { error } = this.state;
    const { menuError } = this.props;
    const errorIndex = Object.keys(error).find(
      key => error[key].isInvalid || error[key].isInvalidQtd || error[key].isInvalidMaxQtd
    );

    return errorIndex ? error[errorIndex] : menuError;
  };

  render() {
    const { newMenu, isLoadingProducts, toggleCategory, isUhuuMtkpc, isLoadingMenus } = this.props;
    const { title, error, marketplaces } = this.state;
    const serializedCategories = newMenu.categories.map(cat => ({
      ...cat,
      options: cat.products,
    }));

    return (
      <styles.Container>
        <styles.Header>
          <styles.Content>
            <EditableTitle
              id="inp-editable-title-menu"
              placeholder="Nome do cardápio"
              onChange={this.handleTitle}
              title={title}
              error={error.title.isInvalid}
              maxLength={45}
            />
            {!isUhuuMtkpc() && (
              <styles.RightInfo>
                <styles.ServiceTypes>{this.renderServices()}</styles.ServiceTypes>
                <MarketplacesTags marketplaces={marketplaces} />
              </styles.RightInfo>
            )}
          </styles.Content>
        </styles.Header>
        <styles.Content>
          <styles.Box>
            <GenericList
              id="select-products"
              title="Selecione os Produtos"
              desc={
                <span>
                  Não encontrou o produto que estava procurando?{' '}
                  <Link id="link-products-list" to="/admin/products">
                    Clique aqui
                  </Link>{' '}
                  para criar um novo produto.
                </span>
              }
              searchPlaceholder="Buscar por produto ou categoria"
              options={serializedCategories}
              isLoading={isLoadingProducts || isLoadingMenus}
              CustomItem={ProductListItem}
              toggleParentItem={toggleCategory}
              customListStyles={{
                height: '305px',
              }}
            />
          </styles.Box>
        </styles.Content>
        <FormFooter
          cancelAction={this.onCancel}
          nextAction={this.saveMenu}
          errorMessage={this.getError().message}
        />
        <DeleteMenuModal container={this} />
        <PublishMenuModal />
        <EditConfirmationModal />
      </styles.Container>
    );
  }
}

const SelectProductsContainer = compose(
  withCreateMenu,
  withMenuModals,
  withMenu,
  withCreateUhuuMenu
);

export default SelectProductsContainer(SelectProducts);



// WEBPACK FOOTER //
// ./src/screens/SelectProducts/index.js